module.exports = __webpack_public_path__ + "static/media/tefinancio_logo_white.06113823.png";